import { numberToPrettyString } from '@cian/utils';

export function rangeAreaStr(prefix: string, gte?: number, lte?: number) {
  return `${prefix}${gte ? ` от ${numberToPrettyString(gte)}` : ''}${lte ? ` до ${numberToPrettyString(lte)}` : ''} м²`;
}
